var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[(_vm.loading)?_c('loader',{attrs:{"styleObject":{height: '160px!important'}}}):_vm._e(),(_vm.prefillParams)?_c('triggers-view',{attrs:{"prefillParams":_vm.prefillParams},on:{"save":_vm.saveEvent}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }